<template lang="pug">
  v-content
    v-container.text-xs-center
      h1 Seite nicht gefunden (404)

</template>

<script>
export default {
}
</script>
